
import { FFmpeg } from "@ffmpeg/ffmpeg";
import { fetchFile } from "@ffmpeg/util";

const ffmpeg = new FFmpeg();

let isLoaded = false;

export async function convertAudio(file, options = {}) {

    if (!file) return null;

    const {
        outputFormat = "mp3",
        bitrate = "128k",
    } = options;

    console.log("=================================");
    console.log("convertAudio START");
    console.log("file:", file.name);
    console.log("type:", file.type);
    console.log("size:", file.size);
    console.log("=================================");


    // ========================================
    // FFmpeg LOAD
    // ========================================

    if (!isLoaded) {

        console.log("STEP 1: FFmpeg LOAD START");

        try {

            await ffmpeg.load();

            isLoaded = true;

            console.log("STEP 1: FFmpeg LOAD DONE");

        } catch (e) {

            console.error(
                "STEP 1 ERROR: FFmpeg LOAD",
                e
            );

            throw e;
        }
    }


    // ========================================
    // ファイル名
    // ========================================

    const extension =
        file.name.split(".").pop()?.toLowerCase() || "wav";

    const id = Date.now();

    const inputName =
        `input_${ id }.${ extension } `;

    const outputName =
        `output_${ id }.${ outputFormat } `;


    console.log("inputName:", inputName);
    console.log("outputName:", outputName);


    // ========================================
    // fetchFile
    // ========================================

    console.log("STEP 2: fetchFile START");

    let inputData;

    try {

        inputData = await fetchFile(file);

        console.log(
            "STEP 2: fetchFile DONE",
            inputData
        );

        console.log(
            "inputData length:",
            inputData?.length
        );

    } catch (e) {

        console.error(
            "STEP 2 ERROR: fetchFile",
            e
        );

        throw e;
    }


    // ========================================
    // writeFile
    // ========================================

    console.log(
        "STEP 3: writeFile START",
        inputName
    );

    try {

        await ffmpeg.writeFile(
            inputName,
            inputData
        );

        console.log(
            "STEP 3: writeFile DONE",
            inputName
        );

    } catch (e) {

        console.error(
            "STEP 3 ERROR: writeFile"
        );

        console.error(
            "error:",
            e
        );

        console.error(
            "constructor:",
            e?.constructor?.name
        );

        console.error(
            "name:",
            e?.name
        );

        console.error(
            "message:",
            e?.message
        );

        console.error(
            "stack:",
            e?.stack
        );

        throw e;
    }


    // ========================================
    // exec
    // ========================================

    console.log(
        "STEP 4: FFmpeg EXEC START"
    );

    try {

        await ffmpeg.exec([
            "-i",
            inputName,
            "-b:a",
            bitrate,
            outputName
        ]);

        console.log(
            "STEP 4: FFmpeg EXEC DONE"
        );

    } catch (e) {

        console.error(
            "STEP 4 ERROR: FFmpeg EXEC"
        );

        console.error(
            "error:",
            e
        );

        console.error(
            "constructor:",
            e?.constructor?.name
        );

        console.error(
            "name:",
            e?.name
        );

        console.error(
            "message:",
            e?.message
        );

        console.error(
            "stack:",
            e?.stack
        );

        throw e;
    }


    // ========================================
    // readFile
    // ========================================

    console.log(
        "STEP 5: readFile START",
        outputName
    );

    let data;

    try {
      console.log("STEP 5: listDir");

      const files = await ffmpeg.listDir("/");
      console.log(
        "FFMPEG FS:",
        files.map(f => ({
          name: f.name,
          type: f.type,
          size: f.size
        }))
      );

      console.log("STEP 5: readFile", outputName);

      const data = await ffmpeg.readFile(outputName);

      console.log("STEP 5 OK");
      console.log("output data length =", data.length);
        data =
            await ffmpeg.readFile(outputName);

        console.log(
            "STEP 5: readFile DONE"
        );

        console.log(
            "output size:",
            data?.length
        );

    } catch (e) {

        console.error(
            "STEP 5 ERROR: readFile"
        );

        console.error(
            "error:",
            e
        );

        console.error(
            "constructor:",
            e?.constructor?.name
        );

        console.error(
            "name:",
            e?.name
        );

        console.error(
            "message:",
            e?.message
        );

        console.error(
            "stack:",
            e?.stack
        );

        throw e;
    }


    // ========================================
    // Blob
    // ========================================

    const blob = new Blob(
        [data.buffer],
        {
            type: "audio/mpeg"
        }
    );


    console.log(
        "Blob:",
        blob.size
    );


    // ========================================
    // File
    // ========================================

    const baseName =
        file.name.replace(/\.[^/.]+$/, "");

    const convertedFile =
        new File(
            [blob],
            `${ baseName }.mp3`,
            {
                type: "audio/mpeg",
                lastModified: Date.now()
            }
        );


    console.log(
        "convertedFile:",
        convertedFile.name,
        convertedFile.size,
        convertedFile.type
    );


    // ========================================
    // cleanup
    // ========================================

    try {

        await ffmpeg.deleteFile(inputName);

    } catch (e) {

        console.warn(
            "delete input failed:",
            e
        );
    }


    try {

        await ffmpeg.deleteFile(outputName);

    } catch (e) {

        console.warn(
            "delete output failed:",
            e
        );
    }


    console.log(
        "convertAudio SUCCESS"
    );


    return convertedFile;
}

